export const API_URL = "https://api.mansouria-app.com/api";
//export const API_URL = "http://127.0.0.1:8000/api";
